/*** Importations *********************************************************************************/

import objectFitImages from 'object-fit-images/dist/ofi.es-modules.js';
import smoothscroll from 'smoothscroll-polyfill';

// Libraries

// import ICAL from "ical.js";
import GLightbox from 'glightbox/dist/js/glightbox.js';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock-upgrade';
import LazyLoad from 'vanilla-lazyload/dist/lazyload.esm.js';
import Swiper from 'swiper';
import {
	Autoplay,
	Pagination,
	Navigation,
} from 'swiper/modules';
import flatpickr from 'flatpickr';
import fr from "flatpickr/dist/l10n/fr.js";

// Scripts Nubee

import SmoothScroller from 'partials/smooth-scroller.js';
import Tabs from 'partials/tabs.js';
import Accordion from 'partials/accordion.js';
import * as functions from 'partials/functions.js';
import 'partials/scroll-interval.js';
import 'partials/target-blank-security.js';
import GLightboxNubee from 'partials/glightbox-nubee.js';
import MobileMenu from 'partials/mobile-menu.js';
import imgCheck from 'partials/img-check.js';
import InfiniteScrollSimple from 'partials/infinite-scroll-simple.js';
import LoadingButton from 'partials/loading-button.js';
import * as cookiesBar from 'partials/cookies-bar.js';
import initFlatpickr from 'partials/init-flatpickr.js';
import NumberInput from 'partials/number-input.js';

// On set toutes les variables globales et évènements qui les modifient ici
import * as globalVarFunctions from 'partials/global-variables.js';

(function() {
	/*** Application des polyfills ********************************************************************/

	(function() {
		objectFitImages();
		smoothscroll.polyfill();

		setTimeout( function() {
			document.body.classList.add( 'loaded' );
		}, 500 )

		if( 'function' != typeof window.Event ) {
			window.Event = CustomEvent;
		}
	}) ();


	/*** Variables globales ***************************************************************************/
	// global-variables.js
	// Chaînes traduisibles et autres variables provenant de theme-functions : window.nubeeGlobals.i18n.monPlugin.nomDeChaine

	globalVarFunctions.setGlobalVariables();
	window.splashScreen = functions.getCookie('splashScreen');


	/*** Les liens avec ancre qui mènent vers la même page deviennent seulement des ancres *******************/
	// Requiert functions.urlsAreSamePage
	// Requiert functions.arrayAllEqual

	(function() {
		let linksWithHash = document.querySelectorAll('a[href*="#"]');

		linksWithHash.forEach( function( thisLink ) {
			if( functions.urlsAreSamePage({ urls: [ thisLink.href, window.location.href ] }) ) {
				thisLink.href = thisLink.hash;
			}
		} );
	}) ();


	/*** Défiler doucement les liens ancres *******************************************************************/
	// Requiert window.smoothScroller (smooth-scroller.js), initialisé dans global-variables.js
	// Ajuster la variable globale window.fixedElHeight

	(function() {
		if( window.smoothScroller ) {
			let smoothScrollLinks = document.querySelectorAll('a[href^="#"]:not([href="#"]):not(.no-smooth-scroll):not([target])');

			smoothScrollLinks.forEach( function( thisEl ) {
				if( functions.scriptsOk( thisEl ) ) {
					thisEl.addEventListener( 'click', function( event ) {
						if( 1 == event.which ) {
							event.preventDefault();
							window.smoothScroller.scrollTo({ target: thisEl.hash });
						}
					} );
				}
			});
		}
	}) ();


	/*** Ne rien faire au clic sur un lien vide (#) ************************************************************/

	(function() {
		document.addEventListener( 'click', function( event ) {
			if( 1 == event.which ) {
				let linkClicked = event.target.closest('a');
				let theHref = linkClicked ? linkClicked.getAttribute('href') : null;

				if( linkClicked && ( ! theHref || '#' == theHref ) && functions.scriptsOk( linkClicked ) ) {
					event.preventDefault();
				}
			}
		} );
	}) ();


	/*** Images et backgrounds différents selon la taille de l'écran ********************************/
	// Requiert img-check.js

	(function() {
		if( 'function' == typeof imgCheck ) {
			window.addEventListener( 'resize', imgCheck );
			imgCheck();
		}
	}) ();


	/*** Lazy load des images et backgrounds *******************************************************************/
	// Requiert vanilla-lazyload

	(function() {
		let loadedEvent = new Event( 'lazyloaded' );

		window.siteLazyLoad = new LazyLoad({
			elements_selector: '.lazy',
			class_loading: 'lazy-loading',
			class_loaded: 'lazy-loaded',
			class_error: 'lazy-error',
			// use_native: true,
			callback_loaded: function( element ) {
				element.dispatchEvent( loadedEvent );
			},
		});
	}) ();


	/*** Antispam maison sur les commentaires ****************************************************************/
	// À moins d'avoir activé le JS, la validation PHP refusera le commentaire.

	(function() {
		let commentForms = document.querySelectorAll('#commentform');

		commentForms.forEach( function( thisForm ) {
			thisForm.addEventListener( 'submit', function() {
				let legitInput = document.createElement( 'input' );
				legitInput.setAttribute( 'type', 'hidden' );
				legitInput.setAttribute( 'name', 'is_legit' );
				legitInput.value = 1;

				thisForm.appendChild( legitInput );
			} );
		} );
	}) ();


	/*** Mettre les label Gravity Forms en mode focus quand ils ont une valeur *************************/
	(function() {
		document.querySelectorAll( '.gfield' ).forEach( function( thisFormRow ) {
			thisFormRow.querySelectorAll( 'input, textarea, select' ).forEach( function( thisField ) {
				if( thisField.value !== '' ) { thisFormRow.classList.add( 'has-value' ); }

				thisField.addEventListener( 'change', function(){
					if( thisField.value !== '' ) {
						thisFormRow.classList.add( 'has-value' );
					} else {
						thisFormRow.classList.remove( 'has-value' );
					}
				} );
			} );
		} );
	}) ();


	/*** Retour en haut **************************************************************************************/
	// Requiert window.smoothScroller (smooth-scroller.js), initialisé dans global-variables.js

	(function() {
		let backToTop = document.querySelector('.back-to-top');

		if( backToTop && functions.scriptsOk( backToTop ) ) {
			backToTop.addEventListener( 'click', function() {
				if( 1 == event.which ) {
					window.smoothScroller.scrollTo({ target: document.querySelector('.all-except-footer') });
				}
			} );
		}
	}) ();


	/*** Menu mobile maison **********************************************************************************/

	(function() {
		new MobileMenu({
			menuSel: '.mobile-menu',
			buttonSel: '.mobile-menu-button',
			// debug: true,
			dropdownParentLinkActive: false,
			// dropdownParentLinkActive: window.vWidth < 1000 ? false : true,

			// Si on agrandit la fenêtre dans ce media query, le menu se ferme automatiquement.
			// closeMediaQuery: '(min-width: 1000px)',

			// viewportMax: { width: 699 },
		});
	}) ();


	/*** InfiniteScrollSimple - Version maison plus légère *************************************************/
	// Requiert infinite-scroll-simple.js
	// Requiert regenerator-runtime (Babel veut ça pour les fonctions async)
	// Voir le début du fichier pour des events sur lesquels vous hooker

	(function() {
		let infiniteContainers = document.querySelectorAll('.iss-container');

		infiniteContainers.forEach(function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				new InfiniteScrollSimple({
					container: thisEl,
					useInner: true,
					animate: true,
					hideButton: false,
					// debug: true,
				});
			}
		} );

	}) ();


	/*** LoadingButton - bouton pour AJAX avec preloader intégré *******************************************/

	(function() {
		let buttons = document.querySelectorAll('.loading-button');

		buttons.forEach(function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				new LoadingButton({
					buttonEl: thisEl,
					debug: false,
				});
			}
		} );
	}) ();


	(function() {
		new Swiper( '.page-block .swiper-standard', {
			modules: [ Navigation, Autoplay ],
			speed: 400,
			spaceBetween: 40,
			slidesPerView: 1.1,
			direction: 'horizontal',
			loop: false,
			touchEventsTarget: 'wrapper',
			preventInteractionOnTransition: true,
			preventClicks: false,
			preventClicksPropagation: false,
			effect: 'slide',
			preloadImages: true,
			shortSwipes: true,
			watchSlidesProgress: true,
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				700: { slidesPerView: 2, },
			},
			on: {
				beforeLoopFix: function( ) {
					window.siteLazyLoad.update();
				}
			},
		});

		new Swiper( '.page-block-columns .block-columns-swiper', {
			modules: [ Autoplay ],
			autoplay: false,
			speed: 400,
			spaceBetween: 40,
			slidesPerView: 1,
			direction: 'horizontal',
			loop: true,
			touchEventsTarget: 'wrapper',
			preventInteractionOnTransition: true,
			preventClicks: false,
			preventClicksPropagation: false,
			effect: 'slide',
			preloadImages: true,
			shortSwipes: true,
			watchSlidesProgress: true,
			lazy: {
				loadPrevNext: true,
			},
			breakpoints: {
				700: { enabled: false },
			},
			on: {
				beforeLoopFix: function( ) {
					window.siteLazyLoad.update();
				}
			},
		});

		new Swiper( '.page-block .swiper-lodging', {
			enabled: false,
			modules: [ Navigation, Autoplay ],
			speed: 400,
			spaceBetween: 0,
			slidesPerView: 1,
			direction: 'horizontal',
			loop: false,
			// touchEventsTarget: 'wrapper',
			// preventInteractionOnTransition: true,
			preventClicks: true,
			preventClicksPropagation: true,
			effect: 'slide',
			preloadImages: true,
			shortSwipes: true,
			watchSlidesProgress: true,
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				700: {
					spaceBetween: 40,
					slidesPerView: 2,
					enabled: true,
				},
			},
			on: {
				beforeLoopFix: function( ) {
					window.siteLazyLoad.update();
				}
			},
		});

		new Swiper( '.page-block-team .swiper', {
			modules: [ Navigation ],
			speed: 400,
			spaceBetween: 30,
			slidesPerView: 1.1,
			direction: 'horizontal',
			loop: false,
			touchEventsTarget: 'wrapper',
			preventInteractionOnTransition: true,
			watchSlidesProgress: true,
			preventClicks: false,
			preventClicksPropagation: false,
			effect: 'slide',
			preloadImages: true,
			shortSwipes: true,
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				700: { slidesPerView: 3, spaceBetween: 40, },
				1400: { slidesPerView: 4, spaceBetween: 40, },
				2000: { slidesPerView: 5, spaceBetween: 40, },
			},
			on: {
				beforeLoopFix: function( ) {
					window.siteLazyLoad.update();
				}
			},
		});

	}) ();


	/*** Empêcher la taille d'un élément de se réajuster une fois le chargement terminé ***********************/

	(function() {
		let lockedHeightEls = document.querySelectorAll('.lock-height-on-load');

		window.addEventListener( 'load', function() {
			lockedHeightEls.forEach( function( thisEl ) {
				if( functions.scriptsOk( thisEl ) ) {
					thisEl.style.height = thisEl.offsetHeight + 'px';
					thisEl.style.minHeight = 0;
					thisEl.style.maxHeight = 'none';
				}
			} );
		} );
	}) ();


	/*** Select qui redirigent quand on choisit une option ******************************************************/
	// Requiert functions.urlsAreSamePage
	// Requiert functions.arrayAllEqual

	(function() {
		let linkSelects = document.querySelectorAll('.link-select');

		linkSelects.forEach( function( thisSelect ) {
			if( functions.scriptsOk( thisSelect ) ) {
				[ 'change', 'keypress' ].forEach( function( eventName ) {
					thisSelect.addEventListener( eventName, function() {
						let selectedOption = thisSelect.options[ thisSelect.selectedIndex ];
						let targetUrl = selectedOption.dataset.url;

						if( targetUrl ) {
							if( /^#.+/.test( targetUrl ) ) {
								window.smoothScroller.scrollTo({ target: targetUrl });
							} else if( ! functions.urlsAreSamePage({ urls: targetUrl }) ) {
								window.location.href = targetUrl;
							}
						}
					} );
				} );
			}
		} );
	}) ();


	/*** Donner la même hauteur à un groupe d'éléments **********************************************************/

	(function() {
		window.addEventListener( 'load', function() {
			let sameHeightGroups = document.querySelectorAll('.same-height-group');

			sameHeightGroups.forEach( function( thisGroup ) {
				if( functions.scriptsOk( thisGroup ) ) {
					let minWidth = thisGroup.dataset.sameHeightMinWidth || 0;
					let sameHeightEls = thisGroup.querySelectorAll('.same-height');
					let highestHeight = 0;

					if( window.vWidth >= minWidth ) {
						sameHeightEls.forEach( function( thisEl ) {
							highestHeight = Math.max( thisEl.clientHeight, highestHeight );
						} );

						sameHeightEls.forEach( function( thisEl ) {
							thisEl.style.minHeight = highestHeight + 'px';
						} );
					}
				}
			} );
		} );
	}) ();


	/*** ProgressiveFadeIn - effet d'apparition lorsque dans le viewport *****************************************/
	// Requiert functions.progressiveFadeIn
	// Options dans progressive-fade-in.scss
	(function() {
		let fadeInItems = document.querySelectorAll('.progressive-fade-in');

		fadeInItems.forEach( function( thisEl ) {
			functions.progressiveFadeIn( thisEl );

			window.addEventListener( 'scrollinterval', function() {
				functions.progressiveFadeIn( thisEl );
			} );
		} );
	}) ();



	/*** Onglets ***************************************************************************************/
	// Requiert tabs.js


	(function() {
		let tabsContainers = document.querySelectorAll('.tabs-block');

		tabsContainers.forEach( function( thisEl ) {
			new Tabs({
				container: thisEl,
				debug: false,
			});
		} );
	}) ();



	/*** Accordion *************************************************************************************/
	// Requiert accordion.js


	(function() {
		let accordionsEl = document.querySelectorAll('.accordion .accordion-item');

		accordionsEl.forEach( function( el ) {
			new Accordion( el );
		} );
	}) ();


	/*** Lightbox et popups avec GLightbox ******************************************************************/
	// Requiert GLightbox (glightbox)
	// Requiert glightbox-nubee.js

	(function() {
		// Éléments seuls.
		let lightboxEls = document.querySelectorAll('.lightbox');
		lightboxEls.forEach( function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				new GLightboxNubee({
					links: thisEl,
					// debug: true,
				});
			}
		} );

		// Galeries. (Attention de donner une classe différente à chaque galerie de la page.)
		// Utilisez data-lightbox-element-class="ma-classe" sur .lightbox-gallery pour l'identifier.
		let lightboxGals = document.querySelectorAll('.lightbox-gallery');
		lightboxGals.forEach( function( thisGal ) {
			if( functions.scriptsOk( thisGal ) ) {
				new GLightboxNubee({
					galleryParent: thisGal,
					// debug: true,
				});
			}
		} );

		// On peut maintenant accéder aux instances à partir des liens ou du parent de la galerie :
		// <un lien lightbox ou un div galerie>._GLightboxNubee
		// <un lien lightbox ou un div galerie>._GLightbox
	}) ();


	/*** Aller voir s'il y a des annonces a afficher *******************************/
	( function() {

		if( window.splashScreen !== '' ) {

			setTimeout( function( ) {

				let formData = new FormData();

				formData.append( 'action', 'popup' );
				formData.append( 'post_id', nubeeGlobals.current_post.post_id );
				formData.append( 'post_type', nubeeGlobals.current_post.post_type );
				formData.append( 'nonce', nubeeGlobals.nubeethemeNonce );

				fetch( nubeeGlobals.ajaxUrl, {
					method: 'POST',
					credentials: 'same-origin',
					body: formData
				})
				.then( function( response ) {
					// The API call was successful!
					return response.text();
				}).then( function( html ) {

					if( html ) {

						// Convert the HTML string into a document object
						let parser = new DOMParser(),
						doc = parser.parseFromString( html, 'text/html' ),
						popups = document.getElementById('popups');

						// Vider le contenu du wrapper d'annonce au cas
						var popupsChildren = Array.prototype.slice.call( popups.childNodes );

						// Remove each child node
						popupsChildren.forEach( function ( child ) {
							popups.removeChild( child );
						} );

						popups.innerHTML = html;

						let nbPopups = doc.querySelectorAll('.popup').length;

						if( nbPopups > 0 ) {
							disableBodyScroll( popups.querySelector('.content'), { reserveScrollBarGap: true } );
							popups.classList.remove('is-hidden');

							// Mettons les bons src aux images (images lazy - src appliqués plus tard)
							if( 'function' == typeof imgCheck ) {
								imgCheck();
							}

							if( 'function' == typeof window.siteLazyLoad.update ) {
								window.siteLazyLoad.update();
							}
						}

						document.getElementById('close-popup').addEventListener( 'click', function (event) {
							event.preventDefault();

							enableBodyScroll( popups.querySelector('.content'), { reserveScrollBarGap: true } );

							let currentDate = new Date();

							let expirationDate = new Date(
								currentDate.getFullYear(),
								currentDate.getMonth(),
								currentDate.getDate() + 1,
								0, 0, 0
							);

							popups.querySelectorAll( '.popup' ).forEach( function( thisPopup ) {
								document.cookie = thisPopup.id + "=is-hidden; expires=" + expirationDate + "; path=/";
							});

							popups.classList.add( 'is-hidden' );


						}, false );
					}


				}).catch( function( error ) {
					// There was an error
					console.warn('Something went wrong.', error);
				});

			}, 50 );
		}

	} ) ();



	/*** Boutons +/- des input type number *******************************************************************/
	// Requiert NumberInput (number-input.js)


	(function() {
		let inputs = document.querySelectorAll('.input-number');

		inputs.forEach( function( thisInput ) {
			let inputInstance = new NumberInput({
				input: thisInput,
			});
		} );
	}) ();



	/*** Datepickers avec flatpickr ***************************************************************************/
	// Requiert initFlatpickr (init-flatpickr.js)
	// Requiert flatpickr

	(function() {
		let dateFields = document.querySelectorAll('.gform-datepicker');

		dateFields.forEach( function( thisField ) {
			initFlatpickr( thisField );
		} );

	}) ();


	// Module de booking général
	(function() {
		let bf_fake_form = document.querySelectorAll( '.bf-fake-form' );

		if( bf_fake_form.length > 0 ) {

			let bf_real_form = document.getElementById( 'bf_real_form' ),
				begindateInput = bf_real_form.querySelector( 'input[name="begindate"]' ),
				enddateInput = bf_real_form.querySelector( 'input[name="enddate"]' ),
				roomAge1Input = bf_real_form.querySelector( 'input[name="roomAge1"]' );

			bf_fake_form.forEach( function( thisFakeForm ) {

				let dateRangeFields = thisFakeForm.querySelectorAll('.date-range-picker'),
					capacityInput = thisFakeForm.querySelectorAll('input[name="capacity"]');

				dateRangeFields.forEach( function( thisField ) {

					let thisFlatpick = flatpickr( thisField, {
						mode: "range",
						minDate: "today",
						dateFormat: "d/m/Y",
						inline: thisField.classList.contains('inline'),
						locale: window.nubeeGlobals.languageCode,

						onChange: function( selectedDates, dateStr, instance ) {

							if( selectedDates[0] !== undefined ) {
								begindateInput.value = flatpickr.formatDate( selectedDates[0], "d/m/Y" );

								if( selectedDates[1] !== undefined ) {
									enddateInput.value = flatpickr.formatDate( selectedDates[1], "d/m/Y" );
								} else {
									enddateInput.value = flatpickr.formatDate( selectedDates[0], "d/m/Y" );
								}
							}

						}
					} );

				} );

				capacityInput.forEach( function( thisEl ) {

					thisEl.addEventListener( 'change', function() {

						let value = [];

						// On va mettre à jour le champs de la liste d'âge des occupants
						if( parseInt( thisEl.value ) > 0 ) {
							for( let i = 1; i <= parseInt( thisEl.value ); ++ i ) {
								value.push( 40 );
							}
						}

						roomAge1Input.value = value.join( ',' );

					});

				});

				thisFakeForm.addEventListener( 'submit', function( e ) {

					e.preventDefault();

					bf_real_form.submit();

				} );

			});

		}

	}) ();

	// Module de booking des pages de détails d'hébergements
	(function() {
		if( document.querySelectorAll( '.lodging-booking-form' ).length > 0 ) {

			let lbfFakeForm = document.getElementById('lbf_fake_form'),
				lbfForm = document.getElementById('lbf_form'),
				lbfFormFieldset = lbfFakeForm.querySelector('fieldset'),

				dateRangeField = lbfFakeForm.querySelector('.lbf-date-range-picker'),
				lodgingSelect = document.getElementById('lbf_select'),
				nbAdultInput = lbfFakeForm.querySelector('input[name="change_adult"]'),
				nbChildInput = lbfFakeForm.querySelector('input[name="change_children"]'),

				catcodeInput = lbfForm.querySelector('input[name="catcode"]'),
				roomtcodeInput = lbfForm.querySelector('input[name="roomtcode"]'),
				begindateInput = lbfForm.querySelector('input[name="begindate"]'),
				enddateInput = lbfForm.querySelector('input[name="enddate"]'),
				roomAgeInput = lbfForm.querySelector('input[name="roomAge1"]'),
				theButton = lbfForm.querySelector('.the-button'),

				maxOccupancy = lbfFakeForm.dataset.maxOccupancy,

				thisFlatpick;


			// Initiation de Flatpickr
			thisFlatpick = flatpickr( dateRangeField, {
				mode: "range",
				minDate: "today",
				dateFormat: "d/m/Y",
				inline: true,
				locale: window.nubeeGlobals.languageCode,
				disable: [
					function( date ) { return true; }
				],

				onChange: function( selectedDates, dateStr, instance ) {

					if( selectedDates[0] !== undefined ) {
						begindateInput.value = flatpickr.formatDate( selectedDates[0], "d/m/Y" );

						if( selectedDates[1] !== undefined ) {
							enddateInput.value = flatpickr.formatDate( selectedDates[1], "d/m/Y" );
						} else {
							enddateInput.value = flatpickr.formatDate( selectedDates[0], "d/m/Y" );
						}
					}

					theButton.removeAttribute( 'disabled' );

				}
			} );

			// Action sur le sélect d'habitation
			if( lodgingSelect !== null ) {
				lodgingSelect.addEventListener( 'change', function() {
					lbfFormFieldset.setAttribute( 'disabled', true );
					if( lodgingSelect.value !== '' ) {

						fetchDisabledDates( thisFlatpick, parseInt( lodgingSelect.value ) );

						thisFlatpick.clear();

						catcodeInput.value = lodgingSelect.options[lodgingSelect.selectedIndex].dataset.catcode;
						roomtcodeInput.value = lodgingSelect.options[lodgingSelect.selectedIndex].dataset.roomtcode;
					}
				} );
			}

			// Call the function to fetch disabled dates on page load or at any time
			if( dateRangeField.dataset.calendarId !== undefined && dateRangeField.dataset.calendarId !== '' ) {
				fetchDisabledDates( thisFlatpick, dateRangeField.dataset.calendarId );
			}

			// Action sur les champs d'occupation pour s'assurer qu'ils respectent l'occupation maximale du chalet
			lbfFakeForm.querySelectorAll('.occupancy-input').forEach( function( thisEl ) {

				thisEl.addEventListener( 'change', function() {
					let value = [];

					// On va changer dynamiquement le max des inputs dépendament du nombre total dans chaque
					if( parseInt( nbAdultInput.value ) < maxOccupancy ) {
						nbAdultInput.setAttribute( 'max', ( maxOccupancy - parseInt( nbChildInput.value ) ) );
						nbChildInput.removeAttribute( 'disabled' );
					} else if( parseInt( nbAdultInput.value ) > maxOccupancy ) {
						nbAdultInput.value = maxOccupancy;
						nbChildInput.value = 0;
						nbChildInput.setAttribute( 'disabled', true );
					} else {
						nbChildInput.value = 0;
						nbChildInput.setAttribute( 'disabled', true );
					}

					if( parseInt( nbChildInput.value ) < maxOccupancy ) {
						nbChildInput.setAttribute( 'max', ( maxOccupancy - parseInt( nbAdultInput.value ) ) );
						nbAdultInput.removeAttribute( 'disabled' );
					} else if( parseInt( nbChildInput.value ) >= maxOccupancy - 1 ) {
						nbChildInput.value = maxOccupancy - 1;
						nbAdultInput.value = 1;
					} else {
						nbAdultInput.value = 0;
					}

					// On va mettre à jour le champs de la liste d'âge des occupants
					lbfFakeForm.querySelectorAll('.occupancy-input').forEach( function( thisElForValue ) {
						if( parseInt( thisElForValue.value ) > 0 ) {
							for( let i = 1; i <= parseInt( thisElForValue.value ); ++ i ) {
								value.push( ( thisElForValue.classList.contains('adult') ? 40 : 10 ) );
							}
						}
					} );

					roomAgeInput.value = value.join( ',' );

				} );
			} );

			// Function to fetch disabled dates and apply them to the Flatpickr instance
			function fetchDisabledDates( flatpickrInstance, calendar_id ) {
				lbfFakeForm.classList.add( 'loading' );

				const xhr = new XMLHttpRequest();

				// Set up the request to the AJAX URL
				xhr.open( 'POST', nubeeGlobals.ajaxUrl, true );
				xhr.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded' );

				// Set the nonce in the request headers for CSRF protection
				xhr.setRequestHeader( 'X-WP-Nonce', nubeeGlobals.nubeethemeNonce );

				// Handle the response
				xhr.onload = function() {
					if( xhr.status === 200 ) {
						const response = JSON.parse( xhr.responseText );

						if( response.success ) {
							// Update the specific Flatpickr instance with disabled dates
							// console.log( flatpickrInstance );
							flatpickrInstance.set( 'disable', response.data );
							lbfFormFieldset.removeAttribute( 'disabled' );

							lbfFakeForm.classList.remove( 'loading' );

							// console.log( response.data );
							// return response.data;

						} else {
							console.log( 'Error fetching dates:', response.data );
						}
					} else {
						console.log( 'Request failed. Returned status of ' + xhr.status );
					}
				};

				// Send the request with the nonce
				xhr.send(
					'action=get_disabled_dates' +
					'&nonce=' + encodeURIComponent( nubeeGlobals.nubeethemeNonce ) +
					'&calendar_id=' + encodeURIComponent( calendar_id )
				);
			}
		}

	}) ();

	/*** Faire afficher les options du booking-form ************************************************************/
	(function() {

		let bookingForm = document.querySelectorAll( '.booking-form-wrapper' );

		if( bookingForm !== null ) {
			bookingForm.forEach( function( thisForm ) {

				let optionsBtn = thisForm.querySelector('.option-opener'),
					optionsWrapper = thisForm.querySelector('.options-wrapper');

				if( optionsWrapper !== null && optionsBtn !== null ) {

					optionsBtn.addEventListener( 'click', function( event ) {

						if( optionsBtn.classList.contains( 'closed' ) ) {

							optionsWrapper.classList.remove('closed');
							optionsBtn.classList.remove( 'closed' );
							optionsBtn.querySelector('.opener').innerText = '[-]';

							window.smoothScroller.scrollTo({ target: optionsBtn });

						} else {

							optionsWrapper.classList.add('closed');
							optionsBtn.classList.add( 'closed' );
							optionsBtn.querySelector('.opener').innerText = '[+]';

						}

					} );

				}


			} );

			let bookingFormDesktop = document.querySelector( '.booking-form' ),
				bookingFormPopup = document.querySelector( '.booking-form-popup' );

			if( bookingFormDesktop !== null && bookingFormPopup !== null ) {

				let buttonFind = bookingFormDesktop.querySelector( '.button-find' ),
					bookingFormPopupInner = bookingFormPopup.querySelector( '.booking-form-popup-inner' );

				if( buttonFind !== null ) {

					buttonFind.addEventListener( 'click', function( event ) {
						if( window.vWidth < 1000 ) {
							event.preventDefault();

							if( bookingFormPopup.classList.contains( 'closed' ) ) {

								disableBodyScroll( bookingFormPopupInner, { reserveScrollBarGap: true } );
								bookingFormPopup.classList.remove('closed');

							} else {

								enableBodyScroll( bookingFormPopupInner, { reserveScrollBarGap: true } );
								bookingFormPopup.classList.add('closed');

							}
						}
					} );

					bookingFormPopup.querySelector('.close-popup').addEventListener( 'click', function( event ) {
						event.preventDefault();

						enableBodyScroll( bookingFormPopupInner, { reserveScrollBarGap: true } );
						bookingFormPopup.classList.add('closed');
					} );

				}

			}
		}



	}) ();

	/*** Gestion des préférence de cookies ***************************************/
	(function() {
		window.acceptedCookies = functions.getCookie('acceptedCookies');

		if( 'function' == typeof cookiesBar.cookieConsent ) {
			cookiesBar.cookieConsent();
		}
	}) ();

	/*** Faire fonctionner le sélecteur de langue custom ***********************************************/
	(function() {

		document.querySelectorAll('.language-switcher').forEach( function( thisEl ) {

			thisEl.addEventListener( 'change', function( event ) {
				window.location = thisEl[ thisEl.selectedIndex ].dataset.url;
			} );

		} );

	}) ();

	/*** Faire fonctionner le sélecteur de devise ******************************************************/
	(function() {

		// Faire fonctionner le sélecteur de devise
		let currencySelector = document.querySelectorAll( '.currency-selector' ),
			currencyBoxes = document.querySelectorAll( '.lodging-price' );

		window.currencyCookie = functions.getCookie('currencyCookie');

		// On va vérifier si le cookie existe et le définir sinon
		if( window.currencyCookie === '' ) {
			document.cookie = "currencyCookie=cad; max-age=2592000; path=/";
			window.currencyCookie = 'cad'
		}

		currencySelector.value = window.currencyCookie;

		// On va mettre le prix de toutes les boîtes de prix dans la devise choisi par l'utilisateur
		if( currencyBoxes !== null ) {
			currencyBoxes.forEach( function( thisPriceEl ) {

				let priceEl = thisPriceEl.querySelector('.new-price'),
				currencyEl = thisPriceEl.querySelector('.currency');

				priceEl.innerText = priceEl.dataset[ window.currencyCookie ];
				currencyEl.innerText = currencyEl.dataset[ window.currencyCookie ];

			} );
		}

		if( currencySelector !== null ) {
			currencySelector.forEach( function( thisEl ) {

				// Mettre les boites de sélection de devise à la valeur dans le cookie (pour que ça fonctionne même avec litespeed)
				thisEl.value = window.currencyCookie;

				// Si la valeur est changée, on va mettre le prix de toutes les boîtes de prix dans la devise choisi par l'utilisateur
				thisEl.addEventListener( 'change', function() {

					if( thisEl.value !== window.currencyCookie ) {

						document.cookie = "currencyCookie=" + thisEl.value + "; max-age=2592000; path=/";
						window.currencyCookie = thisEl.value

						if( currencyBoxes !== null ) {
							currencyBoxes.forEach( function( thisPriceEl ) {

								let priceEl = thisPriceEl.querySelector('.new-price'),
								currencyEl = thisPriceEl.querySelector('.currency');

								priceEl.innerText = priceEl.dataset[ window.currencyCookie ];
								currencyEl.innerText = currencyEl.dataset[ window.currencyCookie ];

								thisEl.nextElementSibling.classList.remove( 'msg-hidden' );

								setTimeout( function() {
									thisEl.nextElementSibling.classList.add( 'msg-hidden' );
								}, 2500 );

							} );
						}

					}

				} );

			} );
		}

	}) ();

	/*** Fonctionnement du splash screen ******************************************************/

	(function () {

		// La personne n'a jamais vu le splashScreen (ou du moins pas depuis moins d'un mois), donc on l'affiche
		if( window.splashScreen === '' ) {

			let splashScreen = document.getElementById( 'splashScreen' ),
				splashForm = splashScreen.querySelector('form');

			// On va blur le body
			document.body.classList.add( 'splash-is-visible' );

			// Afficher le splash screen
			splashScreen.classList.remove( 'is-hidden' );

			let theFormdata = new FormData( splashForm );

			theFormdata.append( 'nonce', nubeeGlobals.nubeethemeNonce );

			splashForm.addEventListener( 'submit', function( event ) {

				event.preventDefault();

				fetch( nubeeGlobals.ajaxUrl, {
					method: 'POST',
					credentials: 'same-origin',
					body: theFormdata,
				})
				.then( function( response ) {
					if ( response.ok ){
						return response.json();
					} else {
						console.log("erreur");
					}
				}).then( function( json ) {

					if( json.success === true ) {
						document.cookie = "splashScreen=1; max-age=2592000; path=/";
						window.location = json.data.redirect_uri;
					}

				});

			} );

		}

	}) ();


	/*** Interactivité de la carte du site ******************************************************/
	(function() {

		let theSiteMap = document.getElementById('the-site-map');

		if( theSiteMap !== null && ! document.body.classList.contains('splash-is-visible') ) {
			let siteMapLinks = theSiteMap.querySelectorAll('.open-popup'),
				theMapPopup = document.getElementById('the-map-popup'),
				theMapPopupContent = document.getElementById('the-map-popup-content'),
				closeButton = theMapPopup.querySelector('.close'),
				theMapLegend = theSiteMap.querySelector('#legende'),
				theMapMap = theSiteMap.querySelector('#carte');

			// Si l'écran est trop petit on va masquer la légende
			if( window.vWidth < 850 ) {
				theSiteMap.setAttribute("viewBox", "0 0 480.02 628.58");
			}

			let closeMapPopop = function( event ){
				theMapPopup.style.opacity = 0;
				setTimeout( function() {
					theMapPopup.classList.add( 'hidden' );
				}, 600 );

				theMapPopup.removeEventListener( 'click', closeMapPopop );
			};

			// On va synchroniser les effets d'hover
			theMapLegend.querySelectorAll('.open-popup').forEach( function( thisEl ) {
				thisEl.addEventListener('mouseenter', function() {
					theMapMap.querySelector('.open-popup[data-id=' + thisEl.dataset.id + ']').classList.add( 'hovered' );
				});
				thisEl.addEventListener('mouseleave', function() {
					theMapMap.querySelector('.open-popup[data-id=' + thisEl.dataset.id + ']').classList.remove( 'hovered' );
				});
			});

			theMapMap.querySelectorAll('.open-popup').forEach( function( thisEl ) {
				thisEl.addEventListener('mouseenter', function() {
					theMapLegend.querySelector('.open-popup[data-id=' + thisEl.dataset.id + ']').classList.add( 'hovered' );
				});
				thisEl.addEventListener('mouseleave', function() {
					theMapLegend.querySelector('.open-popup[data-id=' + thisEl.dataset.id + ']').classList.remove( 'hovered' );
				});
			});

			if( siteMapLinks !== null ) {
				siteMapLinks.forEach( function( elem ) {

					elem.addEventListener( 'click', function( event ) {
						event.preventDefault();

						let elemID = functions.hyphenToCamelCase( elem.dataset.id ),
						at_least_one_item = false,

						image = theMapPopup.querySelector( '.image' ),
						the_image = theMapPopup.querySelector( '.the-image' ),

						the_title = theMapPopup.querySelector( '.the-title' ),
						the_excerpt = theMapPopup.querySelector( '.excerpt' ),

						the_cta = theMapPopup.querySelector( '.cta' ),
						the_cta_link = theMapPopup.querySelector( '.cta-link' ),

						the_icon = theMapPopup.querySelector( '.the-icon' );

						if( elemID !== null ) {

							// Modifier l'image
							if( theMapPopupContent.dataset[ elemID + 'Image' ] !== undefined ) {
								the_image.src = theMapPopupContent.dataset[ elemID + 'Image' ];
								image.classList.remove( 'hidden' );
								at_least_one_item = true;
							} else {
								image.classList.add( 'hidden' );
							}

							// Modifier l'icône
							if( the_icon !== null ) {
								the_icon.style.backgroundImage = "url('" + theMapPopupContent.dataset.iconsSpriteUrl + "#" + elem.dataset.id + "')";
								the_icon.classList.remove( 'hidden' );
							} else {
								the_icon.classList.add( 'hidden' );
							}

							// Modifier le titre
							if( theMapPopupContent.dataset[ elemID + 'Title' ] !== undefined ) {
								the_title.innerText = theMapPopupContent.dataset[ elemID + 'Title' ];
								the_title.classList.remove( 'hidden' );
								at_least_one_item = true;
							} else {
								the_title.classList.add( 'hidden' );
							}

							// Modifier l'excerpt
							if( theMapPopupContent.dataset[ elemID + 'Excerpt' ] !== undefined ) {
								the_excerpt.innerText = theMapPopupContent.dataset[ elemID + 'Excerpt' ];
								the_excerpt.classList.remove( 'hidden' );
								at_least_one_item = true;
							} else {
								the_excerpt.classList.add( 'hidden' );
							}

							// Modifier le lien
							if( theMapPopupContent.dataset[ elemID + 'Link' ] !== undefined && theMapPopupContent.dataset[ elemID + 'LinkTitle' ] !== undefined ) {
								the_cta_link.innerText = theMapPopupContent.dataset[ elemID + 'LinkTitle' ];
								the_cta_link.href = theMapPopupContent.dataset[ elemID + 'Link' ];
								the_cta.classList.remove( 'hidden' );
								at_least_one_item = true;
							} else {
								the_cta.classList.add( 'hidden' );
							}

							if( at_least_one_item ) {
								theMapPopup.classList.remove( 'hidden' );
								setTimeout( function() {
									theMapPopup.style.opacity = 1;
								}, 50 );
							}

							theMapPopup.addEventListener( 'click', function( event ) {
								if( event.target.id === 'the-map-popup' ) {
									closeMapPopop(event);
								}
							} );
						}

					});

				} );
			}

			closeButton.addEventListener( 'click', function( event ) {
				event.preventDefault();

				closeMapPopop(event);
			} );
		}

	}) ();

	/*** Désactiver le bouton Réserver du menu sur mobile (pour le dropdown) ******************************************************/

	document.querySelectorAll( '.menu-reserver > a' ).forEach( function( thisButton ) {

		thisButton.addEventListener( 'click', function( e ) {
			if( window.vWidth < 1000 ) {
				e.preventDefault();
			}
		} );

	} );



}) ();